import { axios } from "utils";

import { ADMIN_SOIL_SIGHT_URL } from "consts";

import { ValidationRun } from "models";

export const startValidationRun = async (versionTag: string, forceRerun?: boolean): Promise<{ runId: string; cached: boolean }> =>
  axios.post(`${ADMIN_SOIL_SIGHT_URL}/validation-runs`, { versionTag, forceRerun });

export const getValidationRun = async (runId: string): Promise<ValidationRun> => axios.get(`${ADMIN_SOIL_SIGHT_URL}/validation-runs/${runId}`);
